import { useTranslation } from 'react-i18next';
import { Text } from '@/ui';
import { PlanBadge } from '../../../components/PlanBadge';

type Props = {
  phoneNumber?: string | null;
  /** When provided, the missing-phone state becomes a clickable "Add" pill. */
  onAddPhone?: () => void;
};

// SMS-enabled family orgs surface each member's phone here. A missing number
// silently disables texting, so it's shown as an attention pill rather than
// muted text that blends into the row.
export const MemberPhone = ({ phoneNumber, onAddPhone }: Props) => {
  const { t } = useTranslation('settingsModal', {
    keyPrefix: 'organizations.member',
  });

  if (phoneNumber) {
    return (
      <Text color="customgray.mid" fontSize="sm">
        {phoneNumber}
      </Text>
    );
  }

  if (onAddPhone) {
    return (
      <PlanBadge
        _hover={{ bg: 'destructive.100' }}
        as="button"
        cursor="pointer"
        tone="attention"
        onClick={onAddPhone}
      >
        {t('add_phone')}
      </PlanBadge>
    );
  }

  return <PlanBadge tone="attention">{t('no_phone')}</PlanBadge>;
};
